/* src/app/shared/components/bottom-navigation-modal/bottom-navigation-modal.component.scss */
.title-container {
  margin: 20px;
}
.title-container ion-label {
  font-size: 18px;
  font-family: var(--ion-font-family);
  font-weight: 400;
  color: var(--ion-color-light-contrast);
}
ion-item {
  --background: transparent;
  --border-radius: 20px;
  padding: 5px 10px 10px 5px;
}
.selected {
  --background: rgba(var(--ion-color-primary-rgb),0.2);
}
/*# sourceMappingURL=bottom-navigation-modal.component.css.map */
